import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import { FaArrowRight } from "react-icons/fa6";
import { GetText } from './config/helper';

export default class Error403 extends Component {

  render() {
    return (
      <div className="error403">
        <Container>
          <h1 className="mb-4">{GetText() ? "Akses ditolak" : "Access denied"}</h1>
          <p></p>
          <div className="mt-4">
            <p>{GetText() ? "Maaf, Anda tidak diperkenankan untuk mengakses halaman ini." : "We're sorry, but you're not allowed to access this page."}</p>
            <span className="link-more" onClick={() => {window.location.href = "/"}}>{GetText() ? "Kembali ke Beranda" : "Back to Home"} <FaArrowRight/></span>
          </div>
        </Container>
      </div>
    );
  }
}